import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ImportantHighlight = styled.span`
  ${fontStyle('base')};
  font-weight: bold;
`;

export const $LineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-grow: 2;
`;
export const $Line = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.mainTextColor};
  margin: 0 ${spacing('lg')};
  width: 100%;
  height: 51%;
  padding: 0 ${spacing('lg')};
`;

export const $Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing('sm')};
`;

export const $PriceField = styled.div`
  min-width: 70px;
  text-align: right;
`;
